<div class="modal-body p-3">
  <app-line-chart
    [header]="header"
    [yAxisName]="yAxisName"
    [xKey]="xKey"
    [yKey]="yKey"
    [yKey2]="yKey2"
    [xAxisName]="xAxisName"
    [yName]="yName"
    [yName2]="yName2"
    [yFormat]="yFormat"
    [xRotation]="xRotation"
    [data$]="data$"
    [height]="600"
    (togglePreview)="onClose()"
  ></app-line-chart>
</div>
